import React, { useEffect, useState, useMemo } from "react"
import { Table, Row, Col, Input, Modal, Form, Label } from "reactstrap"
import { useNavigate } from "react-router-dom"
import { useTable, usePagination, useGlobalFilter } from "react-table"

// common
import Pagination from "components/Common/Pagination"
import { fetchNodeData, FetchNodeDeleteData, FetchNodePostData, FetchNodePutData } from "utils/common-fetchData"
import secureLocalStorage from "react-secure-storage"
import Loader from "pages/Separate/Loader"
import Swal from "sweetalert2"
import { LinkedinAccountsColumns } from "utils/columns/settings/LinkedinCols"
import Select from "react-select"
import { useSelector } from "react-redux"

function TableContainer({ columns, data, setStatus }) {
  const [fixedContent, setFixedContent] = useState(false)

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter,
    usePagination
  )

  const { pageIndex, pageSize, globalFilter } = state

  document.addEventListener("scroll", () => {
    setFixedContent(window.scrollY > 165)
  })

  const navigate = useNavigate()

  return (
    <div className="px-2">
      <div
        className={`flex-column fixed-buttons ${
          fixedContent ? "d-flex" : "d-none"
        }`}
      >
        <button
          onClick={() => setStatus(true)}
          className="btn btn-purple border-radius fix-btn"
        >
          <i className="fas fa-plus me-2"></i>
          <span className="text-nowrap">Add Linkedin Account</span>
        </button>
        {/* <a
          onClick={() => navigate(-1)}
          className="btn btn-red border-radius fix-btn"
        >
          <i className="dripicons-cross me-2 icon-center"></i>
          <span>Cancel</span>
        </a> */}
      </div>

      <Row className="mb-2">
        <Col lg={2}>
          <select
            className="border-radius form-select"
            style={{ width: "100px" }}
            value={pageSize}
            onChange={e => setPageSize(Number(e.target.value))}
          >
            {[10, 20, 30, 40, 50].map(size => (
              <option key={size} value={size}>
                Show {size}
              </option>
            ))}
          </select>
        </Col>
        <Col className="d-flex justify-content-end">
          <div className="me-4">
            <div className="search-box d-inline-block">
              <div className="position-relative">
                <input
                  onChange={e => setGlobalFilter(e.target.value)}
                  type="text"
                  className="border-radius form-control rounded h-100"
                  placeholder="Search..."
                  value={globalFilter || ""}
                />
                <i className="bx bx-search-alt search-icon"></i>
              </div>
            </div>
          </div>
          <div>
            <a
              className="border-radius btn btn-purple"
              onClick={() => setStatus(true)}
            >
              <i className="fas fa-plus me-2 icon-size"></i>Add LinkedIn Account
            </a>
            <a
              className="border-radius btn text-white ms-md-2 btn-red"
              onClick={() => navigate(-1)}
            >
              <i className="dripicons-cross me-2 icon-center"></i>Cancel
            </a>
          </div>
        </Col>
      </Row>

      <Table className="table table-bordered mt-4" {...getTableProps()}>
        <thead 
        // className={fixedContent ? "fixed-setting-header" : ""}
        >
          {headerGroups.map((headerGroup, i) => (
            <tr key={i} {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column, index) => (
                <th
                  key={index}
                  className={column.className || ""}
                  {...column.getHeaderProps()}
                >
                  {column.render("Header")}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row, i) => {
            prepareRow(row)
            return (
              <tr {...row.getRowProps()} key={i}>
                {row.cells.map((cell, index) => (
                  <td
                    className={cell.column.className || ""}
                    key={index}
                    {...cell.getCellProps()}
                  >
                    {cell.render("Cell")}
                  </td>
                ))}
              </tr>
            )
          })}
        </tbody>
      </Table>

      <Row className="justify-content-md-end justify-content-center align-items-center">
        <Pagination
          gotoPage={gotoPage}
          previousPage={previousPage}
          canPreviousPage={canPreviousPage}
          nextPage={nextPage}
          canNextPage={canNextPage}
          pageIndex={pageIndex}
          pageOptions={pageOptions}
        />
      </Row>
    </div>
  )
}

const LinkedinAssignees = () => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([])
  const [editStatus, setEditStatus] = useState(false)
  const [addStatus, setAddStatus] = useState(false)
  const [username, setUsername] = useState("")
  const [editId, setEditId] = useState(null)
  const generalData = useSelector(
    state => state?.GeneralData?.generalData.users
  )
  const [selectedAssignees, setSelectedAssignees] = useState([])

  const getData = async () => {
    const response = await fetchNodeData(
      setLoading,
      "linkedin/set",
      secureLocalStorage?.getItem("auth_token")
    )
    console.log("response.data: ", response.data);
    setData(response.data)
  }

  useEffect(() => {
    getData()
  }, [])

  const updateType = (id, username, assignees = []) => {
    setUsername(username)
    setEditId(id)

    if (!Array.isArray(generalData)) {
      setSelectedAssignees([])
      setEditStatus(true)
      return
    }

    const matchedOptions = generalData.filter(opt =>
      assignees.some(a => Number(a.id) === Number(opt.value))
    )

    setSelectedAssignees(matchedOptions)
    setEditStatus(true)
  }

  const deleteContractType = async id => {
    Swal.fire({
      title: "Are you sure?",
      text: "This account will be deleted!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
    }).then(async result => {
      if (result.isConfirmed) {
        const res = await FetchNodeDeleteData(
          setLoading,
          `linkedin/set`,
          id
        )

        if (res?.data?.success) {
          getData()
          Swal.fire({ icon: "success", text: "Account deleted" })
        }
      }
    })
  }

  const handleEditSubmit = async () => {
    try {
      const payload = {
        username,
        assignee: selectedAssignees.map(a => a.value), // 🔑 IDs
      }

      const res = await FetchNodePutData(
        setLoading,
        `linkedin/set`,
        editId,
        payload,
      )

      if (res?.data?.success) {
        setEditStatus(false)
        setUsername("")
        setSelectedAssignees([])
        getData()

        Swal.fire({
          icon: "success",
          text: "LinkedIn Account Updated Successfully",
        })
      }
    } catch (err) {
      Swal.fire({ icon: "error", text: err.message })
    }
  }

  const handleAddSubmit = async () => {
    try {
      const payload = {
        username,
        assignee: selectedAssignees.map(a => a.value), // 🔑 IDs only
      }

      const res = await FetchNodePostData(
        setLoading,
        "linkedin/set",
        secureLocalStorage.getItem("auth_token"),
        payload
      )

      if (res?.data?.success) {
        setAddStatus(false)
        setUsername("")
        setSelectedAssignees([])
        getData()

        Swal.fire({
          icon: "success",
          text: "LinkedIn Account Added Successfully",
        })
      }
    } catch (err) {
      Swal.fire({ icon: "error", text: err.message })
    }
  }

  const columns = useMemo(
    () => LinkedinAccountsColumns(updateType, deleteContractType),
    []
  )

  return (
    <div>
      {loading && <Loader />}
      <Row>
        <Col lg={12} className="p-0">
          <div className="responsive-table">
            <TableContainer
              columns={columns}
              data={data}
              setStatus={setAddStatus} // Updated to open add modal
            />
          </div>
        </Col>

        {/* Edit Modal */}
        <Modal isOpen={editStatus} size="md" centered>
          <div className="modal-header">
            <h5 className="modal-title mt-0">Edit Account</h5>
            <button
              type="button"
              onClick={() => {
                setEditStatus(false)
                setUsername("") // Clear input on close
                setSelectedAssignees([])
              }}
              className="btn-modal-close"
            >
              <span aria-hidden="true" className="btn-modal-span">
                ×
              </span>
            </button>
          </div>
          <div className="modal-body">
            <Form className="row">
              <div className="mb-3 col-md-12">
                <Label>Account Name</Label>
                <Input
                  type="text"
                  className="form-control"
                  value={username}
                  onChange={e => setUsername(e.target.value)}
                  placeholder="Enter Account Name"
                />
              </div>
              <div className="mb-3 col-md-12">
                <Label>Assignee</Label>
                <Select
                  placeholder="Select Member"
                  className="basic-multi-select"
                  classNamePrefix="select"
                  options={generalData}
                  closeMenuOnSelect={false}
                  isMulti
                  value={selectedAssignees}
                  onChange={setSelectedAssignees}
                />
              </div>
              <div className="mt-20">
                <button
                  type="button"
                  className="border-radius btn btn-purple"
                  onClick={handleEditSubmit}
                >
                  Submit
                </button>
              </div>
            </Form>
          </div>
        </Modal>

        {/* Add Modal */}
        <Modal isOpen={addStatus} size="md" centered>
          <div className="modal-header">
            <h5 className="modal-title mt-0">Add Account</h5>
            <button
              type="button"
              onClick={() => {
                setAddStatus(false)
                setUsername("") // Clear input on close
                setSelectedAssignees([])
              }}
              className="btn-modal-close"
            >
              <span aria-hidden="true" className="btn-modal-span">
                ×
              </span>
            </button>
          </div>
          <div className="modal-body">
            <Form className="row">
              <div className="mb-3 col-md-12">
                <Label>Account Name</Label>
                <Input
                  type="text"
                  className="form-control"
                  value={username}
                  onChange={e => setUsername(e.target.value)}
                  placeholder="Enter Account Name"
                />
              </div>
              <div className="mb-3 col-md-12">
                <Label>Assignee</Label>
                <Select
                  placeholder="Select Member"
                  className="basic-multi-select"
                  classNamePrefix="select"
                  options={generalData}
                  closeMenuOnSelect={false}
                  isMulti
                  value={selectedAssignees}
                  onChange={setSelectedAssignees}
                />
              </div>
              <div className="mt-20">
                <button
                  type="button"
                  className="border-radius btn btn-purple"
                  onClick={handleAddSubmit}
                >
                  Submit
                </button>
              </div>
            </Form>
          </div>
        </Modal>
      </Row>
    </div>
  )
}

export default LinkedinAssignees
